import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import List from "../Components/Move Order/List";
import View from "../Components/Move Order/View";
import { useSelector } from "react-redux";
import * as utils from "../Utils/comman";
import Add from "../Components/Move Order Ui/Add";
import AssetsHistory from "../Components/Assets/AssetsHistory";

function MoveOrder() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();
  const [currentOrder, setCurrentorder] = useState({});
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [invertId, setInvertId] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  function renderComponent() {
    switch (comp) {
      case "list":
        return (
          <List
            comp={comp}
            onChange={handleChange}
            rowData={rowData}
            setIsEdit={setIsEdit}
          />
        );
      case "view":
        return <View comp={comp} rowData={rowData} onChange={handleChange} />;

      case "edit":
        return (
          <Add
            comp={comp}
            rowData={rowData}
            onChange={handleChange}
            isEdit={isEdit}
          />
        );

        case "moveOrder":
          return (
            <Add
              comp={comp}
              rowData={rowData}
              onChange={handleChange}
              isEdit={isEdit}
            />
          );
    
      // default:
      //   return (
      //     <Add
      //       comp={comp}
      //       rowData={rowData}
      //       onChange={handleChange}
      //       currentOrder={currentOrder}
      //     />
      //   );
    }
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Move Order</h1>
          </div>
          {renderComponent()}
        </section>
      </div>
    </Layout>
  );
}

export default MoveOrder;
